

import { render } from 'react-dom';

import './style.scss';
import Style from './Style';
import Forms from './Forms';

// MailChimp Directory
document.addEventListener('DOMContentLoaded', () => {
	const allBlockDirectory = document.querySelectorAll('.wp-block-mcb-mailchimp');
	allBlockDirectory.forEach(directory => {
		const attributes = JSON.parse(directory?.dataset?.attributes);
		const dataInfo = JSON.parse(directory?.dataset?.mcbinfo || "{}");
		const { elements, content, config } = attributes;
		const { apiKey, audienceId } = config;
		const { key } = dataInfo;

		if (!key && !apiKey || !audienceId) {
			return <span> </span>
		}

		render(<>
			<Style attributes={attributes} clientId={attributes.cId} />

			<Forms attributes={attributes} apiKey={key} >
				{(elements.title && content.title.length > 0) && <h2 dangerouslySetInnerHTML={{ __html: content?.title }} />}

				{(elements.desc && content.desc.length > 0) && <p dangerouslySetInnerHTML={{ __html: content?.desc }} />}
			</Forms>
		</>, directory);

		directory?.removeAttribute('data-attributes');
	});
});
